import close from "@/public/assets/ic-close-white.svg";
import styles from "./SubscribeModal.module.scss";
import Image from "next/image";
import { Alert, Box, Grid2 as Grid, Stack, useMediaQuery } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { blogHeaderRedux } from "@/app/store/blog-header/reducers";
import { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Constants from "@/utils/constants";
import { envConfig } from "@/envConfig";

const SubscibeModal = ({ open, onClose }) => {
  const isMediumScreen = useMediaQuery("(max-width: 1200px)");
  const isSmallScreen = useMediaQuery("(max-width: 899px)");
  const isDesktopScreen = useMediaQuery("(min-width: 1201px)");

  const isLandScape = useMediaQuery("(max-height: 450px)");

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const dispatch = useDispatch();
  const createSubscribe = (data) =>
    dispatch(blogHeaderRedux.actions.createSubscribeRequest(data));
  const createSubscribeReset = () =>
    dispatch(blogHeaderRedux.actions.createSubscribeReset());

  const subscribeState = useSelector(
    (state) => state?.blogHeader?.createSubscribeDetails
  );

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required.");
    } else if (!validateEmail(email)) {
      setError("Please enter a valid email id.");
    } else {
      setError("");
      createSubscribe({ email });
    }
  };

  useEffect(() => {
    if (subscribeState?.isError || subscribeState?.isSuccess) {
      setSnackbarMessage(
        subscribeState.isError
          ? subscribeState.error || "Something Went Wrong"
          : "You have successfully subscribed!"
      );
      setSnackbarSeverity(subscribeState.isError ? "error" : "success");
      setOpenSnackBar(true);
    }

    if (subscribeState?.isSuccess) {
      setEmail("");
    }
  }, [subscribeState?.isError, subscribeState?.isSuccess]);

  useEffect(() => {
    if (subscribeState?.isError || subscribeState?.isSuccess) {
      setOpenSnackBar(true);
    }

    if (subscribeState?.isSuccess) {
      setEmail("");
      setTimeout(() => {
        onClose();
      }, 1000);
    }
  }, [subscribeState?.isError, subscribeState?.isSuccess]);

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
    createSubscribeReset();
  };

  const handleCloseDrawer = () => {
    setEmail("");
    setError("");
    onClose();
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  return (
    <>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Drawer
        transitionDuration={700}
        className={styles.popupContainer}
        anchor={"bottom"}
        open={open}
        onClose={handleCloseDrawer}
        ModalProps={{
          disableScrollLock: false,
        }}
        BackdropProps={{
          style: { backgroundColor: "transparent" },
        }}
        sx={{
          "& .MuiDrawer-paper": {
            background:
              "linear-gradient( to bottom,rgba(12, 10, 10, 0) 6.26%, rgba(12, 10, 10, 0) 16.26%, rgba(10, 9, 9, 0.5) 80.57%)",

            backdropFilter: "blur(150px)",

            maskImage:
              "linear-gradient(to top, rgb(13, 12, 12) 60%, rgba(10, 6, 6, 0.6) 80%, transparent 100%)",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            minHeight: isSmallScreen ? "700px" : "500px",
            padding: isMediumScreen ? "1rem" : "3rem",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Inter",
            width: "100%",
            alignItems: "center",
            position: "fixed",
            bottom: "0px",
            zIndex: 9999,
            boxShadow: "none",
            overflow: "hidden",
            display: "flex",
            justifyContent: "flex-end",
          },
        }}
      >
        <Box
          width={isMediumScreen ? "100%" : "65%"}
          sx={
            isLandScape
              ? { height: "80vh", overflow: "scroll", scrollbarWidth: "none" }
              : {}
          }
        >
          <div className={styles.closeIconWrapper}>
            <div
              onClick={handleCloseDrawer}
              className={styles.closeIconContent}
            >
              <Image
                src={close.src}
                className={styles.closeIcon}
                alt={"Close icon"}
                width={25}
                height={25}
              />
            </div>
          </div>

          <Grid container spacing={isMediumScreen ? 3 : 10}>
            <Grid size={{ sm: 12, md: 6, lg: 6 }}>
              <p
                className={styles.typography1}
                style={{ textAlign: isSmallScreen ? "center" : "left" }}
              >
                SIMPLE BLOGS
              </p>
              <p className={styles.typography2}>
                Stay tuned for the latest update, stories & inspiration.
              </p>
            </Grid>

            <Grid
              size={{ sm: 12, md: 6, lg: 6 }}
              sx={{
                width: "100%",
              }}
            >
              <div className={styles.inputHolder}>
                <input
                  type="email"
                  placeholder="Your e-mail"
                  value={email}
                  onChange={(e) => {
                    if (
                      e.target.value?.length <= Constants.InputCharacterLimit
                    ) {
                      setEmail(e.target.value);
                      setError("");
                    }
                  }}
                  style={{ border: "none", marginRight: "2px" }}
                  maxLength={Constants.InputCharacterLimit}
                />
                <div className={styles.divider}></div>

                <p
                  style={{
                    color: "red",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    textAlign: isSmallScreen ? "center" : "left",
                    height: "20px",
                  }}
                >
                  {isSmallScreen && error && error}
                </p>

                <button onClick={handleSubscribe}>SUBSCRIBE</button>
              </div>
              {!isSmallScreen && error && (
                <p
                  style={{
                    color: "red",
                    marginTop: "-10px",
                    marginBottom: "10px",
                    fontFamily: "Inter",
                    fontSize: "16px",
                  }}
                >
                  {error}
                </p>
              )}
              <div>
                <p className={styles.typography3}>
                  By clicking the Subscribe button you agree to our{" "}
                </p>

                <p className={styles.typography4}>
                  <Link
                    className={styles.typography4}
                    href={
                      envConfig.ENV_TYPE === "development"
                        ? "https://website-stage.simpleenergy.in/privacy-policy"
                        : "https://www.simpleenergy.in/privacy-policy"
                    }
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>{" "}
                  &{" "}
                  <Link
                    className={styles.typography4}
                    href={
                      envConfig.ENV_TYPE === "development"
                        ? "https://website-stage.simpleenergy.in/terms-and-condition"
                        : "https://www.simpleenergy.in/terms-and-condition"
                    }
                    target="_blank"
                  >
                    Terms
                  </Link>
                </p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Drawer>
    </>
  );
};

export default SubscibeModal;
